import React from 'react';
import { classes } from './ComplexPhone.st.css';
import { Dropdown, } from 'wix-ui-tpa';
import { COUNTRIES_CODES_LIST } from './utils';
export const CountryCodeDropdown = ({ invalidMessage, theme, disabled, isMobile, countryCode, onCountryCodeChange }) => (React.createElement("div", { className: classes.dropdownWrapper },
    React.createElement(Dropdown, { "data-hook": "country-code", theme: theme, className: classes.dropdown, disabled: disabled, initialSelectedId: countryCode, error: !!invalidMessage, onChange: (selectedOption) => onCountryCodeChange(selectedOption.id), options: COUNTRIES_CODES_LIST.map((code) => ({
            id: code.key,
            value: code.value,
            subtitle: code.key,
            isSelectable: true,
        })), mobileNativeSelect: !!isMobile })));
//# sourceMappingURL=CountryDropdown.js.map